import { render, staticRenderFns } from "./AssinadorDocumento.vue?vue&type=template&id=5fb00172&scoped=true"
import script from "./AssinadorDocumento.vue?vue&type=script&lang=js"
export * from "./AssinadorDocumento.vue?vue&type=script&lang=js"
import style0 from "./AssinadorDocumento.vue?vue&type=style&index=0&id=5fb00172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb00172",
  null
  
)

export default component.exports